import { ClearOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Form, Input, Row, Space, Table } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React, { useEffect, useState } from "react";
import { AdminService } from "src/resources/AdminService";

const Campuses = () => {
  const [form] = Form.useForm();
  const [initialRender, setInitialRender] = useState(true);
  const [campuses, setCampuses] = useState(null);
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      AdminService.getCampuses().then((data) => {
        setCampuses(data.data);
      });
    }
  }, [initialRender]);

  const onFinish = (values) => {
    console.log(values);
    AdminService.newCampus(values).then((data) => {
      setInitialRender(true);
      onReset();
    });
  };
  const onReset = () => {
    form.resetFields();
  };
  const columns = [
    {
      title: "Campus Name",
      dataIndex: "name",
    },
  ];
  return (
    <div className="max-w-6xl p-2 mx-auto">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
          <Divider orientation="left">Campuses</Divider>
          <Table
            rowKey="id"
            bordered
            size="small"
            dataSource={campuses}
            loading={campuses === null}
            columns={columns}
            className="lg:mr-12 border border-gray-200"
            pagination={false}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
          <Divider orientation="left">Add new Campus</Divider>
          <Form
            form={form}
            onFinish={onFinish}
            onReset={onReset}
            layout="vertical"
          >
            <Form.Item
              label="Campus Name"
              name="name"
              rules={[{ required: true, message: "Campus name is required!" }]}
            >
              <Input placeholder="Please type campus name" />
            </Form.Item>

            <Form.Item className="mt-6">
              <Space>
                <Button
                  type="default"
                  htmlType="reset"
                  icon={<ClearOutlined />}
                >
                  Clear
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                >
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default Campuses;
